
'use strict';

define('component!ButtonComponent',['require','react','prop-types','radium','lib/Podio.Colors'],function (require) {
  'use strict';

  var React = require('react');
  var PropTypes = require('prop-types');
  var Radium = require('radium');
  var PodioColors = require('lib/Podio.Colors');

  var ButtonComponent = function ButtonComponent(props) {

    return React.createElement(
      'button',
      {
        id: props.id,
        name: props.name,
        className: 'button-component ' + props.className,
        disabled: props.disabled,
        tabIndex: props.tabIndex,
        onClick: props.onClick,
        type: props.type },
      props.label
    );
  };

  ButtonComponent.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    styles: PropTypes.object,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.string,
    type: PropTypes.string
  };

  return ButtonComponent;
});
